const RECORD_ID =
  /^(?:\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

// Group failures for different records under the same endpoint by replacing IDs.
// Only these verified routes are normalized; other paths stay unchanged.
// Verified record routes from construct-core 0.4.10's single endpoint metadata.
// Keep this registry explicit: importing model configs here creates a cycle via
// requests, and guessing numeric segments would collapse years and versions.
const instancePaths = new Set([
  '/accounting/invoices/invoice',
  '/accounting/invoices/invoicerow',
  '/accounting/invoices/invoicerecipient',
  '/accounting/payments/invoicepayment',
  '/contracts/apartmentcontract',
  '/contracts/industrialpremisescontract',
  '/contracts/parkingspotcontract',
  '/contracts/outdoorsectioncontract',
  '/contracts/blockcontract',
  '/contracts/othercontract',
]);

export function normalizeApiEndpoint(pathname: string): string {
  const segments = pathname.split('/');
  for (let index = 1; index < segments.length; index++) {
    if (
      RECORD_ID.test(segments[index]) &&
      instancePaths.has(segments.slice(0, index).join('/'))
    ) {
      segments[index] = ':id';
    }
  }
  return segments.join('/');
}
